import React from 'react';
import { SvgIcon } from '@scotia/canvas-react';

export const IconSubtract = props => (
  <SvgIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon id="bounds" points="0 0 24 0 24 24 0 24" />
      <path
        d="M5,12 L19,12"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </SvgIcon>
);
